import React from 'react';
import styled from 'styled-components/macro';
import Button from './Button';
import Tooltip from './Tooltip';

const $RequestAccessTooltip = styled.div`
  padding: 4px 8px;
`;

interface BulkVerifyUploadButtonProps {
  buttonText: string;
  dataCy: string;
  isEnabled: boolean;
  onClick: () => void;
}

const BulkVerifyUploadButton = ({
  buttonText,
  dataCy,
  isEnabled,
  onClick,
}: BulkVerifyUploadButtonProps) => {
  const button = (
    <Button
      type="button"
      data-cy={dataCy}
      styledProps={{
        align: 'end',
      }}
      onClick={isEnabled ? onClick : undefined}
      isDisabled={!isEnabled}
    >
      {buttonText}
    </Button>
  );

  if (!isEnabled) {
    return (
      <Tooltip
        content={<$RequestAccessTooltip>Request access to use this feature</$RequestAccessTooltip>}
        trigger="mouseenter"
        theme="light"
        placement="top"
        styledProps={{ borderRadius: '12px' }}
      >
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default BulkVerifyUploadButton;
